import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { InfoStore } from '../../../stores/hub.calendar.store';
import { InfoModalData, ShowInfoModalActions } from './show.info.modal.provider';

@Component({
  templateUrl: './show.info.modal.component.html',
  styleUrls: ['./show.info.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowInfoModalComponent extends BaseComponent {
  public title: string;
  public info: string[];
  public plainText: string;
  public icons: {
    icon: string;
    color: string;
  }[];
  @Input() showCopy = false;
  @ViewChild('div') public div: ElementRef;
  @ViewChildren('text') content: QueryList<ElementRef>;

  constructor(
    private dialogRef: MatDialogRef<ShowInfoModalComponent>,
    private actions: ShowInfoModalActions,
    public imageService: ImageService,
    private infoStore: InfoStore,
    data: InfoModalData
  ) {
    super();
    this.title = data.title;
    this.icons = data.icons;
    this.info = data.info;
    this.plainText = data.plainText;
    this.showCopy = data.showCopy;
    this.infoStore.infoCommand.takeUntil(this.isDestroyed).subscribe((info: string) => {
      this.info.push(info);
      setTimeout(() => {
        this.content.toArray().forEach((x, index) => {
          x.nativeElement.innerHTML = this.info[index];
        });
      });
    });
  }

  public append(text) {
    this.div.nativeElement.innerHTML += `<div>${text}</div>`;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public copy() {
    this.copyToClip(this.plainText || this.info[0]);
  }

  public async confirm(event: ButtonTriggerEvent) {}

  get code() {
    if (!this.plainText) return '';
    return `<pre style="margin:0"><code>${this.plainText.replaceAll('<', '&lt;').replaceAll('>', '&gt;')}</code></pre>`;
  }

  private copyToClip(content) {
    let aux = document.createElement('input');
    aux.setAttribute('value', content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    alert('Link is copied to the clipboard');
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.info.modal/show.info.modal.component.ts